/* eslint-disable react/no-array-index-key */
import { FC } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import LoyaltyRewardMiniCard from "components/molecules/LoyaltyRewardMiniCard";
import { LoyaltyRewardMiniCardPropsWithId } from "components/molecules/LoyaltyRewardMiniCard/types";
import "./styles.sass";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import useTranslate from "../../../hooks/useTranslate";

export type LoyaltyRankRewardsListProps = {
  nameRank: string;
  rewardsRank: LoyaltyRewardMiniCardPropsWithId[];
  rewardsLevel: LoyaltyRewardMiniCardPropsWithId[][];
};

const LoyaltyRankRewardsList: FC<LoyaltyRankRewardsListProps> = (props) => {
  const { nameRank, rewardsRank, rewardsLevel } = props;
  const t = useTranslate();
  const { isPhone } = useBreakpoint();

  const mapCards = (list: LoyaltyRewardMiniCardPropsWithId[]) =>
    !isPhone ? (
      <div className="LoyaltyRankRewardsList__cards">
        <Swiper
          spaceBetween={16}
          slidesPerView="auto"
          freeMode
          init={false}
          className="LoyaltyRankRewardsList__swiper"
          grabCursor
          direction={isPhone ? "vertical" : "horizontal"}
        >
          {list?.map((card) => (
            <SwiperSlide
              key={card.id}
              className="LoyaltyRankRewardsList__slide"
            >
              <LoyaltyRewardMiniCard
                key={card.id}
                {...card}
                className="LoyaltyRankRewardsList__card"
                isShow
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    ) : (
      <div className="LoyaltyRankRewardsList__cards">
        {list?.map((card) => (
          <LoyaltyRewardMiniCard
            key={card.id}
            {...card}
            className="LoyaltyRankRewardsList__card"
            isShow
          />
        ))}
      </div>
    );

  return (
    <div className="LoyaltyRankRewardsList">
      {mapCards(rewardsRank)}
      {rewardsLevel?.map((rewards, index) => (
        <div key={`${nameRank}-${index}`}>
          <span className="LoyaltyRankRewardsList__level">
            {t(nameRank)} {index + 1}
          </span>
          {mapCards(rewards)}
        </div>
      ))}
    </div>
  );
};

export default LoyaltyRankRewardsList;
